// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__VB63t","range":"MonthRangeSwitch_range__GvTGZ","disabled":"MonthRangeSwitch_disabled__vjK7k"};